import React from "react";

import {
  EXAMPLE_ORGANISATION_ALPHA_AD_URL,
  EXAMPLE_ORGANISATION_ALPHA_NAME,
  EXAMPLE_ORGANISATION_ALPHA_URL,
} from "../../services/constants";

import RaindropCard from "../raindrop-card/raindrop-card.tsx";
import RaindropButton, {
  ButtonStyle,
} from "../raindrop-button/raindrop-button.tsx";
import RaindropLoadingElement from "../raindrop-loading-element/raindrop-loading-element";

import OrganisationListElement from "../organisation-list-element/organisation-list-element.tsx";
import Spacer from "../spacer/spacer";
import { Size } from "../../logic/enums.ts";

const AdvertisementHeader = ({
  organisationName = EXAMPLE_ORGANISATION_ALPHA_NAME,
  organisationSrc = EXAMPLE_ORGANISATION_ALPHA_URL,
  isShowingButton = true,
  onClickSupport = () => {},
}) => {
  const onClickSupportWrapper = (event) => {
    onClickSupport();
    event.stopPropagation();
  };

  return (
    <div className="flex flex-row gap-2 items-center w-full">
      <OrganisationListElement
        name={organisationName}
        presignedUrl={organisationSrc}
        doShowGiveButton={false}
      />

      <Spacer />

      {isShowingButton && (
        <RaindropButton
          title={"Support"}
          onClick={onClickSupportWrapper}
          size={Size.Large}
          style={ButtonStyle.Secondary}
          icon="fa-plus"
        />
      )}
    </div>
  );
};

const AdvertisementContent = ({
  advertisementSrc = EXAMPLE_ORGANISATION_ALPHA_AD_URL,
}) => {
  return (
    <div className="flex flex-col gap-2">
      <img
        src={advertisementSrc}
        alt={""}
        className="w-full h-40 object-cover rounded-lg pt-1"
      />
    </div>
  );
};

const RaindropAdvertisement = ({
  organisationId,
  advertisementSrc,
  organisationName,
  organisationSrc,
  isShowingButton = true,
  onClickGeneral = () => {},
  onClickSupport = () => {},
}) => {
  if (!organisationId) {
    return (
      <RaindropCard>
        <RaindropLoadingElement />
      </RaindropCard>
    );
  }

  return (
    <RaindropCard additionalClasses="cursor-pointer hover:scale-[98%] transition-all ">
      <div className="flex flex-col gap-4 w-full" onClick={onClickGeneral}>
        <AdvertisementContent advertisementSrc={advertisementSrc} />
        <AdvertisementHeader
          organisationName={organisationName}
          organisationSrc={organisationSrc}
          isShowingButton={isShowingButton}
          onClickSupport={onClickSupport}
        />
      </div>
    </RaindropCard>
  );
};

export default RaindropAdvertisement;
